import React, { useState, useEffect, useLayoutEffect, useCallback, useRef } from 'react';
import moment from 'moment';
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery';
import { getData } from "../../serverRequest";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';

const formatDate = (dateString) => {
    return moment(dateString).format('DD/MM/YYYY');
};

export default function HolidayList() {
    const [holidays, setHolidays] = useState([]); // State to store all holiday data
    const [filteredHolidays, setFilteredHolidays] = useState([]); // State to store filtered holiday data
    const [selectedYear, setSelectedYear] = useState(null); // State to store selected year
    const [yearOptions, setYearOptions] = useState([]); // State to store year options from data
    const isMountedRef = useRef(true); // Track if component is mounted
    const holidaysTableRef = useRef(null); // Ref for holidays table
    const optionalHolidaysTableRef = useRef(null); // Ref for optional holidays table
    const holidaysContainerRef = useRef(null); // Ref for holidays container
    const optionalContainerRef = useRef(null); // Ref for optional holidays container

    // Function to extract unique years from holidays data
    const extractYearsFromData = useCallback((holidaysData) => {
        if (!holidaysData || holidaysData.length === 0) return [];
        
        const uniqueYears = [...new Set(holidaysData.map(holiday => holiday.year))];
        return uniqueYears
            .filter(year => year != null) // Filter out null/undefined years
            .sort((a, b) => b - a) // Sort descending (newest first)
            .map(year => ({ value: year, label: year.toString() }));
    }, []);

    // Function to filter holidays by year using the 'year' field from data
    const filterHolidaysByYear = useCallback((holidaysData, year) => {
        return holidaysData.filter(holiday => {
            // Convert both to numbers for comparison to handle string/number mismatches
            return Number(holiday.year) === Number(year);
        });
    }, []);

    // Function to destroy DataTables safely and restore DOM
    const destroyDataTables = useCallback(() => {
        try {
            // Destroy holidays table
            if ($.fn.DataTable.isDataTable('#holidays')) {
                try {
                    const dt = $('#holidays').DataTable();
                    dt.destroy(true);
                } catch (e) {
                    console.warn('Error destroying holidays DataTable:', e);
                }
                
                // Force restore using ref if available, otherwise use jQuery
                if (holidaysContainerRef.current && holidaysTableRef.current) {
                    const container = holidaysContainerRef.current;
                    const table = holidaysTableRef.current;
                    
                    // Check if table is not a direct child of container
                    if (table.parentElement !== container) {
                        // Find the table element (might be inside DataTables wrapper)
                        let tableElement = table;
                        if (table.parentElement && table.parentElement.classList.contains('dataTables_wrapper')) {
                            tableElement = table;
                        }
                        
                        // Ensure table is in container
                        if (tableElement && tableElement.parentElement !== container) {
                            container.appendChild(tableElement);
                        }
                    }
                } else {
                    // Fallback to jQuery approach
                    const holidaysContainer = $('#holidays-container');
                    if (holidaysContainer.length) {
                        const table = holidaysContainer.find('table#holidays');
                        if (table.length === 0) {
                            const wrapper = $('.dataTables_wrapper').has('#holidays');
                            if (wrapper.length) {
                                const tableElement = wrapper.find('table#holidays')[0];
                                if (tableElement && holidaysContainer[0]) {
                                    holidaysContainer[0].appendChild(tableElement);
                                }
                            }
                        }
                    }
                }
            }
            
            // Destroy optional holidays table
            if ($.fn.DataTable.isDataTable('#OptionalHolidays')) {
                try {
                    const dt = $('#OptionalHolidays').DataTable();
                    dt.destroy(true);
                } catch (e) {
                    console.warn('Error destroying OptionalHolidays DataTable:', e);
                }
                
                // Force restore using ref if available, otherwise use jQuery
                if (optionalContainerRef.current && optionalHolidaysTableRef.current) {
                    const container = optionalContainerRef.current;
                    const table = optionalHolidaysTableRef.current;
                    
                    // Check if table is not a direct child of container
                    if (table.parentElement !== container) {
                        // Find the table element (might be inside DataTables wrapper)
                        let tableElement = table;
                        if (table.parentElement && table.parentElement.classList.contains('dataTables_wrapper')) {
                            tableElement = table;
                        }
                        
                        // Ensure table is in container
                        if (tableElement && tableElement.parentElement !== container) {
                            container.appendChild(tableElement);
                        }
                    }
                } else {
                    // Fallback to jQuery approach
                    const optionalContainer = $('#OptionalHolidays-container');
                    if (optionalContainer.length) {
                        const table = optionalContainer.find('table#OptionalHolidays');
                        if (table.length === 0) {
                            const wrapper = $('.dataTables_wrapper').has('#OptionalHolidays');
                            if (wrapper.length) {
                                const tableElement = wrapper.find('table#OptionalHolidays')[0];
                                if (tableElement && optionalContainer[0]) {
                                    optionalContainer[0].appendChild(tableElement);
                                }
                            }
                        }
                    }
                }
            }
        } catch (error) {
            console.warn('Error destroying DataTables:', error);
        }
    }, []);

    // Function to initialize DataTables
    const initializeDataTables = useCallback(() => {
        // Check if component is still mounted
        if (!isMountedRef.current) {
            return;
        }

        // Check if tables exist in DOM
        if ($('#holidays').length === 0 || $('#OptionalHolidays').length === 0) {
            console.log('Tables not found in DOM yet');
            return;
        }

        // Destroy existing DataTable instances if they exist
        destroyDataTables();

        // Initialize DataTables only if component is still mounted
        if (!isMountedRef.current) {
            return;
        }

        try {
            var sort_col = $('#holidays').find("th:contains('ID')")[0]?.cellIndex;
            if (sort_col !== undefined) {
                $('#holidays').DataTable({
                    order: [[sort_col, 'desc']],
                    columnDefs: [
                        {
                            target: 0,
                            visible: false,
                            searchable: false
                        }
                    ],
                });
                console.log('Initialized holidays DataTable');
            } else {
                console.error("Column with text 'ID' not found in holidays table.");
            }

            if (!isMountedRef.current) {
                destroyDataTables();
                return;
            }

            var opsort_col = $('#OptionalHolidays').find("th:contains('ID')")[0]?.cellIndex;
            if (opsort_col !== undefined) {
                $('#OptionalHolidays').DataTable({
                    order: [[opsort_col, 'desc']],
                    columnDefs: [
                        {
                            target: 0,
                            visible: false,
                            searchable: false
                        }
                    ],
                });
                console.log('Initialized OptionalHolidays DataTable');
            } else {
                console.error("Column with text 'ID' not found in OptionalHolidays table.");
            }
        } catch (error) {
            console.error('Error initializing DataTables:', error);
        }
    }, [destroyDataTables]);

    // Handle year change
    const handleYearChange = (selectedOption) => {
        const year = selectedOption.value;
        setSelectedYear(year);
    };

    // Fetch holiday data on component mount
    useEffect(() => {
        const fetchHolidayData = async () => {
            try {
                const resData = await getData('/api/company/holiday?company_id=' + localStorage.getItem('companyId'));
                
                // Check if component is still mounted before updating state
                if (!isMountedRef.current) {
                    return;
                }

                // Safe data access with null checks
                if (resData && resData['data'] && resData['data']['data']) {
                    const data = resData['data']['data'];
                    console.log('Fetched holidays data:', data);

                    setHolidays(data);
                    
                    // Extract years from data and set year options
                    const years = extractYearsFromData(data);
                    console.log('Extracted years:', years);
                    setYearOptions(years);
                    
                    // Set default year: prefer current year if available, otherwise use the latest year in data
                    if (years.length > 0) {
                        const currentYear = new Date().getFullYear();
                        const currentYearOption = years.find(y => y.value === currentYear);
                        const defaultYear = currentYearOption ? currentYear : years[0].value; // Use latest year if current year not available
                        console.log('Setting default year to:', defaultYear);
                        setSelectedYear(defaultYear);
                    }
                } else {
                    console.error('Invalid response structure:', resData);
                }
            } catch (error) {
                console.error('Error fetching holiday data:', error);
            }
        };

        fetchHolidayData();
    }, [extractYearsFromData]);

    // Filter holidays when selectedYear or holidays change
    useEffect(() => {
        if (holidays.length > 0 && selectedYear !== null) {
            const filtered = filterHolidaysByYear(holidays, selectedYear);
            console.log('Filtered holidays for year', selectedYear, ':', filtered);
            setFilteredHolidays(filtered);
        } else if (holidays.length === 0) {
            setFilteredHolidays([]);
        }
    }, [selectedYear, holidays, filterHolidaysByYear]);

    // Reinitialize DataTables when filtered holidays change
    useEffect(() => {
        // Destroy existing DataTables first (synchronously)
        destroyDataTables();
        
        // Wait for DOM to update, then initialize DataTables
        const timer = setTimeout(() => {
            if (isMountedRef.current) {
                initializeDataTables();
            }
        }, 200);

        return () => {
            clearTimeout(timer);
            // Destroy DataTables synchronously before React cleanup
            if (isMountedRef.current) {
                destroyDataTables();
            }
        };
    }, [filteredHolidays, initializeDataTables, destroyDataTables]);

    // Cleanup on component unmount - use useLayoutEffect for synchronous cleanup
    useLayoutEffect(() => {
        return () => {
            isMountedRef.current = false;
            // Destroy DataTables synchronously to restore DOM before React cleanup
            destroyDataTables();
        };
    }, [destroyDataTables]);
    return (
        <>
            <main>
                <div className="relative block py-24 lg:pt-0 px-4">
                    {/* Holidays Header Container */}
                    <div
                        className={
                            "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
                            ("light" === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
                        }
                    >
                        <div className="rounded-t bg-white mb-0 px-6 py-6">
                            <div className="flex items-center">
                                <div className="flex-1">
                                    <h6 className="text-blueGray-700 text-xl font-bold">
                                        Holidays
                                    </h6>
                                </div>
                                <div className="flex items-center justify-center flex-1">
                                    <div className="relative" style={{ width: '150px' }}>
                                        <Select
                                            name="year"
                                            options={yearOptions}
                                            value={selectedYear !== null ? yearOptions.find(option => option.value === selectedYear) : null}
                                            onChange={handleYearChange}
                                            placeholder="Select Year"
                                            isDisabled={yearOptions.length === 0}
                                        />
                                    </div>
                                </div>
                                <div className="flex-1"></div>
                            </div>
                        </div>
                    </div>

                    {/* Annual Leaves Table */}
                    <div
                        className={
                            "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
                            ("light" === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
                        }
                    >
                        <div className="rounded-t mb-0 px-4 py-3 border-0">
                            <div className="flex flex-wrap items-center">
                                <div className="relative w-full px-4 max-w-full flex-grow flex-1 ">
                                    <h3
                                        className={
                                            "font-semibold text-lg " + "text-blueGray-700"
                                        }
                                    >
                                        Annual Leaves
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="block w-full overflow-x-auto py-24 lg:pt-0 px-4">
                            <div style={{ width: '100%', overflowX: 'auto' }}>
                                <div 
                                    ref={holidaysContainerRef}
                                    id="holidays-container" 
                                    key={`holidays-container-${selectedYear}`}
                                >
                                    <table 
                                        ref={holidaysTableRef}
                                        id="holidays" 
                                        key={`holidays-${selectedYear}`}
                                        className="items-center w-full bg-transparent border-collapse"
                                        style={{ width: '100%', margin: 0 }}
                                    >
                                    <thead>
                                        <tr>
                                            <th
                                                className={
                                                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                                                    " bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                                                }
                                            >
                                                ID
                                            </th>
                                            <th
                                                className={
                                                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                                                    ("light" === "light"
                                                        ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                                                        : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                                                }
                                            >
                                                Date
                                            </th>
                                            <th
                                                className={
                                                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                                                    ("light" === "light"
                                                        ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                                                        : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                                                }
                                            >
                                                Holiday Type
                                            </th>
                                            <th
                                                className={
                                                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                                                    ("light" === "light"
                                                        ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                                                        : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                                                }
                                            >
                                                Reason
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredHolidays.map((holiday, index) => (
                                            holiday.is_optional === false ? (
                                                <tr key={index}>
                                                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                                                        {holiday.id}
                                                    </td>
                                                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                                                        {formatDate(holiday.holiday_date)}
                                                    </td>
                                                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                                                        {holiday.holiday_type_display}
                                                    </td>
                                                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                                                        {holiday.holiday_reason}
                                                    </td>
                                                </tr>
                                            ) : ''
                                        ))}
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Optional Leaves Table */}
                    <div
                        className={
                            "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
                            ("light" === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
                        }
                    >
                        <div className="rounded-t mb-0 px-4 py-3 border-0">
                            <div className="flex flex-wrap items-center">
                                <div className="relative w-full px-4 max-w-full flex-grow flex-1 ">
                                    <h3
                                        className={
                                            "font-semibold text-lg " + "text-blueGray-700"
                                        }
                                    >
                                        Optional Leaves
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="block w-full overflow-x-auto py-24 lg:pt-0 px-4">
                            <div style={{ width: '100%', overflowX: 'auto' }}>
                                <div 
                                    ref={optionalContainerRef}
                                    id="OptionalHolidays-container" 
                                    key={`OptionalHolidays-container-${selectedYear}`}
                                >
                                    <table 
                                        ref={optionalHolidaysTableRef}
                                        id="OptionalHolidays" 
                                        key={`OptionalHolidays-${selectedYear}`}
                                        className="items-center w-full bg-transparent border-collapse"
                                        style={{ width: '100%', margin: 0 }}
                                    >
                                    <thead>
                                        <tr>
                                            <th
                                                className={
                                                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                                                    " bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                                                }
                                            >
                                                ID
                                            </th>
                                            <th
                                                className={
                                                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                                                    ("light" === "light"
                                                        ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                                                        : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                                                }
                                            >
                                                Date
                                            </th>
                                            <th
                                                className={
                                                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                                                    ("light" === "light"
                                                        ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                                                        : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                                                }
                                            >
                                                Holiday Type
                                            </th>
                                            <th
                                                className={
                                                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                                                    ("light" === "light"
                                                        ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                                                        : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                                                }
                                            >
                                                Reason
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredHolidays.map((holiday, index) => (
                                            holiday.is_optional === true ? (
                                                <tr key={index}>
                                                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                                                        {holiday.id}
                                                    </td>
                                                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                                                        {formatDate(holiday.holiday_date)}
                                                    </td>
                                                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                                                        {holiday.holiday_type_display}
                                                    </td>
                                                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                                                        {holiday.holiday_reason}
                                                    </td>
                                                </tr>
                                            ) : ''
                                        ))}
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <ToastContainer />
        </>
    );
}
